import { Component, OnInit, OnDestroy } from '@angular/core';
import { EMailFileDetails } from 'src/app/shared/models/iCourrier/email/email-file-details';
import { MailInsert } from 'src/app/shared/models/iCourrier/post/mail-insert';
import { ErrorService } from 'src/app/shared/services/error.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpErrorModalComponent } from 'src/app/components/modals/http-error-modal/http-error-modal.component';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/shared/services/data.service';
import { CourrierCreateModalComponent } from '../../COURRIER-S/courrier-create-modal/courrier-create-modal.component';
import { ContactNewComponent } from '../../CONTACT/contact-new/contact-new.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'primeng/dynamicdialog';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { ParseEmailService } from 'src/app/shared/services/parse-email.service';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MeService } from 'src/app/shared/services/me.service';
import { NavigationEnd, Router } from '@angular/router';
import { MailInfosViaExtraStateRouter } from 'src/app/shared/models/mails/mail';
import { Warnings } from 'src/app/shared/models/iCourrier/httpErrors/warnings.enum';
@Component({
  selector: 'app-circular-menu',
  templateUrl: './circular-menu.component.html',
  styleUrls: ['./circular-menu.component.scss'],
})
export class CircularMenuComponent implements OnInit, OnDestroy {
  public convertedMail: EMailFileDetails;
  public uploadedFiles: File[] = [];
  private ngUnsubscribe = new Subject(); // For errors messages
  public courrier: MailInsert;
  public filesLength: number;
  public showMenu = false;
  public showLinks = false;
  public showUploader = false;
  public right: UserInfo;
  constructor(
    private meService: MeService,
    private errorService: ErrorService,
    private toastr: ToastrService,
    public spinner: NgxSpinnerService,
    private router: Router,
    private dataService: DataService,
    private dialogService: DialogService,
    private parseEmailService: ParseEmailService,
    private mailsService: MailsService
  ) {
    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          this.showMenu = true;
        }
      },
    });
  }

  ngOnInit(): void {
    this.initializeErrors();
    this.getRight();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  getRight() {
    this.meService.getUserInfo().subscribe({
      next: (res: UserInfo) => {
        this.right = res;
      },
    });
  }

  // ATTENTION !!! SANS CETTE FONCTION, LE COPY NE MARCHE PAS !!!
  public onDragEnter(event: DragEvent) {
    event.dataTransfer.dropEffect = 'copy';
    event.preventDefault();
    event.stopPropagation();
  }

  // ATTENTION !!! SANS CETTE FONCTION, LE COPY NE MARCHE PAS !!!
  public onDragOver(event: DragEvent) {
    event.dataTransfer.dropEffect = 'copy';
    event.stopPropagation();
    event.preventDefault();
  }

  public onDrop(event: DragEvent) {
    event.dataTransfer.dropEffect = 'copy';
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      const _files = Array.from(files);
      this.onFileDropped(_files);
    }
  }

  public onFileDropped(files) {
    files.forEach((f) => {
      const fileExtension = f.name.split('.').pop();
      if (
        fileExtension.toLowerCase() === 'msg' ||
        fileExtension.toLowerCase() === 'rtf' ||
        fileExtension.toLowerCase() === 'eml' ||
        fileExtension.toLowerCase() === 'message/rfc822'
      ) {
        this.parseEmail(f);
      }
    });
  }

  public parseEmail(file: File) {
    this.uploadedFiles = [];
    sessionStorage.removeItem('createFromFile');
    this.dataService.setCurrentAttachement(file);
    sessionStorage.setItem('createFromFile', 'true');
    this.uploadedFiles.push(file);
    this.spinner.show();
    this.parseEmailService.parseEmailFile(file, file.name.split('.').pop()).subscribe({
      next: (response) => {
        this.convertedMail = new EMailFileDetails(response);
        const newEntry = new MailInsert({
          dateEntree: new Date(),
          dateDocument: new Date(this.convertedMail.sentOnUtcDateTime),
          datePostale: null,
          dateEcheance: null,
          refExpediteur: null,
          objet: this.convertedMail.subject,
          typeEntrantSortant: 'E',
          sender: this.convertedMail.sender,
          expediteurLibre: this.convertedMail.sender.displayName,
        });

        this.dataService.setMailGlob(newEntry);
        sessionStorage.setItem('newCourrier', JSON.stringify(newEntry));
        this.showUploader = false;
        this.toastr.success('Votre fichier a bien été importé');
        const ref = this.dialogService.open(CourrierCreateModalComponent, {
          styleClass: 'super-compos-modal-content',
          dismissableMask: false,
          width: '70vw',
          closable: false,
          showHeader: false,
          baseZIndex: 1000,
          data: {
            courrierFile: newEntry,
            mailType: 'E',
          },
        });

        document.addEventListener('DOMContentLoaded', function () {
          const modalContent = document.querySelector('.p-dynamic-dialog');
          if (modalContent) {
            modalContent.setAttribute('draggable', 'true');
          }
        });

        ref.onClose.subscribe({
          next: (value) => {
            if (value) {
              this.router.navigate(['/private/ic/tabs/' + value.id]);
            }
          },
        });
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  public saveMail(data: MailInsert, skipFalse?: boolean) {
    this.mailsService.addMail(data, skipFalse).subscribe({
      next: (response) => {
        if (response.workflowStartDefinitionId) {
          this.toastr.success('Flux associé', 'Un flux a été associé à ce courrier');
        }
        this.toastr.success('Succès', 'Votre courrier a été créé!');
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  private initializeErrors() {
    this.errorService
      .getErrors()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (errors) => {
          console.error(errors);
          this.openErrorModal(errors, 'warningMode');
        },
      });
  }

  public openErrorModal(messages: Warnings[], mode: string) {
    const ref = this.dialogService.open(HttpErrorModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Avertissement',
      baseZIndex: 1000,
      data: {
        message: messages,
        mode: mode,
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value === true) {
          this.saveMail(this.courrier, true);
        }
      },
    });
  }

  createContact() {
    this.dialogService.open(ContactNewComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: false,
      showHeader: false,
      baseZIndex: 1000,
      data: {
        modeAnswer: false,
        caller: 'global_file',
      },
    });
  }

  createCourrier(mailType) {
    const data: MailInfosViaExtraStateRouter = {
      mailType: mailType,
      mailMode: 'edit',
      isNew: true,
      isAnswerMode: false,
    };
    this.router.navigate(['/private/ic/new'], { state: data });
  }

  onUploadClick() {
    document.getElementsByClassName('myUploadGlobal')[0].querySelector('input').click();
  }
}
